'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { MdInfo, MdCheckCircle } from 'react-icons/md';

type StartFormInfoboxProps = {
  type: 'success' | 'destructive' | 'info';
  textSuccess?: string;
  textDescructive?: string;
  textInfo?: string;
  className?: {
    success?: string;
    destructive?: string;
    info?: string;
    wrapper?: string;
    text?: string;
    icon?: string;
  };
};

export const StartFormInfobox = (props: StartFormInfoboxProps) => {
  const { t } = useTranslations();

  const getText = () => {
    switch (props.type) {
      case 'success':
        return props.textSuccess || 'Not defined.';
      case 'destructive':
        return props.textDescructive || 'Not defined.';
      case 'info':
        return props.textInfo || 'Not defined.';
    }
  };

  const text = getText();

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg p-4 sm:p-6',
        props.className?.wrapper,
        props.type === 'success' && 'bg-success text-success-foreground',
        props.type === 'success' && props.className?.success,
        props.type === 'destructive' && 'bg-destructive text-destructive-foreground',
        props.type === 'destructive' && props.className?.destructive,
        props.type === 'info' && 'bg-info text-info-foreground',
        props.type === 'info' && props.className?.info,
      )}
    >
      {props.type === 'success' && (
        <MdCheckCircle
          className={cn('h-4 w-4 sm:h-7 sm:w-7 md:h-10 md:w-10', props.className?.icon)}
        />
      )}
      {props.type === 'destructive' && (
        <MdInfo className={cn('h-4 w-4 sm:h-7 sm:w-7 md:h-10 md:w-10', props.className?.icon)} />
      )}
      {props.type === 'info' && (
        <MdInfo className={cn('h-4 w-4 sm:h-7 sm:w-7 md:h-10 md:w-10', props.className?.icon)} />
      )}
      <h1 className={cn('text-sm font-medium sm:text-lg', props.className?.text)}>{t(text)}</h1>
    </div>
  );
};
